import { IAuthState } from "@/interfaces/state";
import store from "@/store/index";

export const headers = () => {
  return {
    Authorization: `Bearer ${(store.state as { auth: IAuthState }).auth.token}`,
  };
};
